export enum PermissionEnum {
  create = 'C',
  read = 'R',
  update = 'U',
  delete = 'D',
  execute = 'E',
}
